import type { ContractorExportData } from './contractors-export-schema';

export const CONTRACTORS_EXPORT_DECIMAL_PLACES = {
  cashDiscountPercentage: 2,
} as const satisfies Partial<Record<keyof ContractorExportData, number>>;
